const SnapShortSvg = ({ size = 8 }) => (
  <svg
    stroke="currentColor"
    className={`-m-[3px] size-${size}`}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.92007 8.56673C3.77967 8.58434 3.63965 8.60314 3.5 8.62311M3.92007 8.56673C4.92892 8.44019 5.95685 8.375 7 8.375C8.04315 8.375 9.07108 8.44019 10.0799 8.56673M3.92007 8.56673L3.69886 11M10.0799 8.56673C10.2203 8.58434 10.3604 8.60314 10.5 8.62311M10.0799 8.56673L10.3011 11M10.3011 11L10.4349 12.4718C10.4699 12.8561 10.1673 13.1875 9.78138 13.1875H4.21862C3.83272 13.1875 3.53012 12.8561 3.56506 12.4718L3.69886 11M10.3011 11H10.9375C11.6624 11 12.25 10.4124 12.25 9.6875V6.01582C12.25 5.38527 11.8021 4.84048 11.1785 4.74717C10.8088 4.69186 10.4367 4.64377 10.0625 4.60306M3.69886 11H3.0625C2.33763 11 1.75 10.4124 1.75 9.6875V6.01582C1.75 5.38527 2.19794 4.84048 2.82155 4.74717C3.19122 4.69186 3.56325 4.64377 3.9375 4.60306M10.0625 4.60306C9.0567 4.49365 8.03491 4.4375 7 4.4375C5.96509 4.4375 4.9433 4.49365 3.9375 4.60306M10.0625 4.60306V2.46875C10.0625 2.10631 9.76869 1.8125 9.40625 1.8125H4.59375C4.23131 1.8125 3.9375 2.10631 3.9375 2.46875V4.60306M10.5 6.625H10.5044V6.62938H10.5V6.625ZM8.75 6.625H8.75438V6.62938H8.75V6.625Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SnapShortSvg;
